import AddTestStepper from "../../components/add/AddTestStepper";
import AddTestPageNavButtons from "./AddTestPageNavButtons";
import React, { useContext } from "react";
import { VideoContext } from "../../context/video_context";
import { CheckCircle2 } from "lucide-react";

type RunTestProps = {
  handlePageChangeUp: any;
  handlePageChangeDown: any;
  handlePageChange: any;
};

const activeStep: number = 4;

export default function RunTest(fn: RunTestProps) {
  const videoContext = useContext(VideoContext);
  const createTest = videoContext?.createTest;
  React.useEffect(() => {
    createTest?.();
  }, []);

  return (
    <div className="w-full py-5 flex flex-col h-full">
      <AddTestStepper activeStep={activeStep} />
      <div className="px-12 py-10 flex flex-col items-start gap-4">
        <div className="flex items-center gap-3">
          <CheckCircle2 className="h-10 w-10 text-primary" />
          <h2 className="text-3xl font-bold">Your Test is Running!</h2>
        </div>
        <p className="text-muted-foreground text-base">
          Your test has been scheduled. Head to the tests page to track its progress.
        </p>
      </div>
      <AddTestPageNavButtons
        step={activeStep}
        handlePageChangeUp={fn.handlePageChangeUp}
        handlePageChangeDown={fn.handlePageChangeDown}
      />
    </div>
  );
}
